"use client"

import styled from "@emotion/styled"
import { Box, Typography } from "@mui/material"
import { useTranslations } from "next-intl"
import Image from "next/image"
import { colors, mediaQueries, sizes } from "ui"
import ButtonWithArrow from "ui/common/bit/ButtonWithArrow"
import CommonTitle from "ui/common/bit/CommonTitle"
import { getNonUmbracoUrl } from "utils"
import { transformProperties } from "utils/simplifyData"
import BlockWrapper from "../common/BlockWrapper"
import IconWithBackground from "../common/bit/IconWithBackground"
import InfoLink from "../common/bit/InfoLink"
import OutlinedButtonWithArrow from "../common/bit/OutlinedButtonWithArrow"

const StyledBlockWrapper = styled(BlockWrapper)`
  ${mediaQueries.desktopM} {
    padding-inline-start: 90px;
    padding-inline-end: 90px;
  }
`
const StyledContainer = styled(Box)`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;

  gap: ${sizes.baseQuadric};
  ${mediaQueries.desktopM} {
    align-items: stretch;
    flex-flow: row wrap;
    justify-content: center;
  }
`
const StyledLinkCard = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 380px;
  max-width: 100%;
  height: auto;
  min-height: fit-content;
  border-radius: ${sizes.borderRadius};
  padding: 12px;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: -4.297px 8.593px 32.225px 0px rgba(2, 1, 64, 0.12);
  gap: ${sizes.baseDouble};
  text-decoration: none;
  ${mediaQueries.desktopM} {
    width: 308px;
    padding: ${sizes.baseTriple};
    gap: ${sizes.baseSingle};
  }
  ${mediaQueries.desktopXl} {
    gap: ${sizes.baseDouble};
  }
`

const StyledTextWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-bottom: auto;
`
const StyledText = styled(Typography)`
  text-align: center;
  color: ${colors.black};
`

const StyledButtonWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  padding-top: 40px;
`

const CardsWithLinksShift = ({ data, id }: any) => {
  const { title, subtitle, itemsList, button } = data
  const t = useTranslations("SEO")
  return (
    <StyledBlockWrapper id={id} style={{ maxWidth: "1440px" }}>
      {(title || subtitle) && (
        <CommonTitle title={title?.value} subtitle={subtitle?.value} />
      )}
      <StyledContainer>
        {itemsList?.blocks?.map((item: any, index: number) => {
          const { primaryColor, button, link, icon, title, text } =
            transformProperties(item?.properties)
          const uniqueKey = `card-${item?.id || ""}-${index}-${Date.now()}`
          return (
            <StyledLinkCard key={uniqueKey}>
              <IconWithBackground
                size={48}
                icon={
                  icon.mediaItems[0] && (
                    <Image
                      src={icon.mediaItems[0]?.url}
                      alt={`${t("iconAlt")}${title?.value}`}
                      fill
                    />
                  )
                }
                backgroundColor={primaryColor?.value || "#00A7B5"}
              />
              <StyledTextWrapper>
                {title?.value && (
                  <Typography variant="h4" component="h3">
                    {title?.value}
                  </Typography>
                )}
                {text?.value && (
                  <StyledText variant="body1">{text?.value}</StyledText>
                )}
              </StyledTextWrapper>
              {button && button?.links[0] && (
                <OutlinedButtonWithArrow
                  href={getNonUmbracoUrl(button?.links[0]?.url)}
                >
                  {button.links[0]?.name}
                </OutlinedButtonWithArrow>
              )}
              {link && (
                <InfoLink
                  href={getNonUmbracoUrl(link?.links[0]?.url)}
                  target={link?.links?.[0]?.target || "_self"}
                >
                  {link?.links[0]?.name}
                </InfoLink>
              )}
            </StyledLinkCard>
          )
        })}
      </StyledContainer>
      {button && button?.links[0] && (
        <StyledButtonWrapper>
          <ButtonWithArrow href={getNonUmbracoUrl(button?.links[0]?.url)}>
            {button.links[0]?.name}
          </ButtonWithArrow>
        </StyledButtonWrapper>
      )}
    </StyledBlockWrapper>
  )
}

export default CardsWithLinksShift
